import { render, staticRenderFns } from "./PreventionList.vue?vue&type=template&id=262864ea&scoped=true"
import script from "./PreventionList.vue?vue&type=script&lang=js"
export * from "./PreventionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262864ea",
  null
  
)

export default component.exports